var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sort__task__control"}},[_c('a',{staticClass:"task-sorting-btn cursor-pointer"},[_c('i',{staticClass:"fas fa-sort"})])])}]

export { render, staticRenderFns }